import type { SubmissionCohort, SubmissionStatus } from '@/types';

export interface ReviewTransitionContext {
  status: SubmissionStatus;
  hasReviews: boolean;
  cohort: SubmissionCohort;
  country: string;
  hasFlightRequests: boolean;
}

export function canChangeStatus({
  status,
  hasReviews,
}: ReviewTransitionContext): boolean {
  return (
    (status === 'received' ||
      status === 'priority_waiting' ||
      status === 'waiting_list') &&
    hasReviews
  );
}

export function canMoveToPriorityWaiting({
  status,
  hasReviews,
  cohort,
}: ReviewTransitionContext): boolean {
  return status === 'received' && hasReviews && cohort === 'priority';
}

export function canAskSelfFinanceTrip({
  status,
  hasReviews,
  country,
  hasFlightRequests,
}: ReviewTransitionContext): boolean {
  return (
    (status === 'received' || status === 'priority_waiting') &&
    hasReviews &&
    (country.toLowerCase() !== 'cl' || hasFlightRequests)
  );
}

export function canWithdraw({ status }: ReviewTransitionContext): boolean {
  return (
    status === 'approved' ||
    status === 'onboarding_request' ||
    status === 'onboarding_expired' ||
    status === 'onboarding_complete'
  );
}
